import { LOG_OUT } from "../login/action";
import { SET_DRIVER_PERMITLIST_STATES, SET_DRIVER_PERMITLIST_STATES_ERROR, SET_DRIVER_PERMIT_RESION, SET_DRIVER_SELECTED_GRID_PERMIT } from "./action";

export const defaultState={
    driverPermitListStateList:[],
    driverSelectedGridPermit:[]
}

function driverPermitListReducer(state=defaultState,action){
    switch (action.type) {
       case SET_DRIVER_PERMITLIST_STATES:
           return{
               ...state,
               driverPermitListStateList:action.payload
            }
            case SET_DRIVER_PERMITLIST_STATES_ERROR:
                return{
                    ...state,
                    driverPermitListStateListError:action.payload
                }
        case SET_DRIVER_SELECTED_GRID_PERMIT:
            return {
                ...state,
                driverSelectedGridPermit:[action.payload]
            }
            case SET_DRIVER_PERMIT_RESION:
                return{
                    ...state,
                    drivervirtualpermitResionText:action.payload
                }
        case LOG_OUT:
            return defaultState;
        default:
          return state;
      }
}

export default driverPermitListReducer;